import { bindActionCreators } from '@reduxjs/toolkit'
import { profileSlice } from 'store/slices/profile'
import { useAppDispatch } from 'store/store'

export const useProfileActions = () => bindActionCreators(profileSlice.actions, useAppDispatch())
